import { defineComponent } from 'vue';
import { tradeAreaClient } from '~/lib/client';
import Spinner from './Spinner.vue';
import _ from 'lodash';
import $ from 'jquery';
import 'ion-rangeslider';
export default defineComponent({
    name: 'AttriubeStep',
    components: { Spinner },
    props: {
        product: {
            type: Object,
            required: true,
        },
        brand: {
            type: Object,
            required: true,
        },
        attr: {
            type: Object,
            required: true,
        },
    },
    emits: ['select'],
    data() {
        return {
            loading: false,
            materials: [],
            selectedMaterial: null,
            filterMaterial: null,
            filterColor: null,
            rangeMin: 0,
            rangeMax: 0,
            sliderInitialized: false,
            galleryContainer: null,
            gallery: null,
            galleryResizeCondVar: false,
        };
    },
    computed: {
        productPrice() {
            let price = Number(this.product.basePrice);
            if (this.selectedPriceMod !== null) {
                price += Number(this.selectedPriceMod.priceMod);
            }
            return price;
        },
        selectedCategories() {
            return this.sortedPriceMods.slice(this.rangeMin, this.rangeMax + 1);
        },
        sortedPriceMods() {
            const sortedPriceMods = Array.from(this.attr.priceMods);
            sortedPriceMods.sort((a, b) => Number(a.priceMod) - Number(b.priceMod));
            return sortedPriceMods;
        },
        selectedPriceMod() {
            if (this.selectedMaterial === null)
                return null;
            const priceMod = this.attr.priceMods.find(
            // eslint-disable-next-line
            (m) => m.categoryName === this.selectedMaterial.priceModCategory);
            return priceMod === undefined ? null : priceMod;
        },
        availableMaterials() {
            return _.uniq(this.materials.map((m) => m.materialTypeLabel));
        },
        availableColors() {
            return _.uniq(this.materials.map((m) => m.colorLabel));
        },
        filteredMateriaByCategory() {
            let scopeMaterials = [];
            for (const priceMod of this.selectedCategories) {
                scopeMaterials = scopeMaterials.concat(this.materials.filter((m) => {
                    let priceDecision = this.filterMaterial === null || m.materialTypeLabel === this.filterMaterial;
                    let colorDecision = this.filterColor === null || m.colorLabel === this.filterColor;
                    let materialDecision = m.priceModCategory === priceMod.categoryName;
                    return priceDecision && colorDecision && materialDecision;
                }));
            }
            return scopeMaterials;
        },
    },
    async beforeMount() {
        this.loading = true;
        const cats = [];
        for (let m of this.attr.priceMods) {
            cats.push(m.categoryName);
        }
        this.materials = await tradeAreaClient.getMaterials({
            priceModCategories: cats,
        });
        this.galleryResizeCondVar = true;
        this.loading = false;
    },
    mounted() {
        let maxHeight = $('.modal__content').height();
        if (maxHeight === undefined)
            return;
        $('.attribute-step > div').css('max-height', maxHeight);
    },
    methods: {
        setGalleryContainer(el) {
            this.galleryContainer = el;
            if (this.gallery === null || this.galleryResizeCondVar === false)
                return;
            // setHeightAsRemainingSpace(this.galleryContainer, this.gallery);
            this.galleryResizeCondVar = false;
        },
        setGallery(el) {
            this.gallery = el;
        },
        selectMaterialFilter(material) {
            this.filterMaterial = this.filterMaterial === material ? null : material;
        },
        selectColorFilter(color) {
            this.filterColor = this.filterColor === color ? null : color;
        },
        selectMaterial(material) {
            this.selectedMaterial = material;
            if (this.selectedPriceMod === null)
                return;
            this.$emit('select', material, this.selectedPriceMod);
        },
        isMaterialSelected(material) {
            return this.selectedMaterial === null
                ? false
                : this.selectedMaterial.id === material.id;
        },
        initPriceRangeSlider(el) {
            if (this.sliderInitialized === true)
                return;
            const max = this.attr.priceMods.length - 1;
            $(el).ionRangeSlider({
                skin: 'round',
                type: 'double',
                min: 0,
                max: max,
                from: 0,
                to: max,
                hide_from_to: true,
                onStart: (range) => this.updateRange(range),
                onChange: (range) => this.updateRange(range),
                prettify: (n) => {
                    if (n === 0)
                        return 'Min';
                    if (n === max)
                        return 'Max';
                    return String(n);
                }
            });
        },
        updateRange(range) {
            this.rangeMin = range.from;
            this.rangeMax = range.to;
        }
    },
});
